import { OnInit, Injectable, OnDestroy } from "@angular/core";
import { Subject, Observable, BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class DashboardService implements OnInit, OnDestroy {
	public dashboard_sidebar: boolean = false;
	public dashboardName = {};
	public dashboardGroupId = {};
	public dashboardGroupName = {};
	public RegionDataSetId = {};
	public dashboardDescription = {};
	public pane_show: boolean = false;
	public push_btn: boolean = false;
	public customize = new Subject();
	public dashboardRename = new Subject();
	public paneData = new Subject();
	public col_num = new Subject();
	public alone_col = new Subject();
	public full_dt = new Subject();
	public chartTypeChange = new Subject();
	public chartUpdate = new Subject();
	public DashbordGroup = new Subject();
	public portletEdit = new Subject();
	public addOrdelPortlet = new Subject();
	public switchLabelConfig = new Subject();
	public refreshGadget = new Subject();
	public startRefresh = new Subject();
	public dashboardNavigate = new BehaviorSubject(false);
	public DashboardGroupData = [];
	public shareGroup = [];
	public colorsTotal = [
		"#0b5496",
		"#0081ff",
		"#22cce2",
		"#606ede",
		"#8598f7",
		"#00a744",
		"#12c177",
		"#fdbf5e",
		"#ff8a48",
		"#ea4258",
	];
	public create_btn = new Subject();
	public downloadDashboard = new Subject();
	public shareUsers = {};
	// public irrDetail = new Subject();
	public irrDetail: boolean = false;
	public enter_dashboard: boolean = false;
	public leftMenuBar = new Subject();
	public createGroupDashboard = new Subject();
	public create_status: boolean = false;
	public reportName;
	public reportSetting;
	public reportId;
	public sharedOrCustomize: boolean = false;
	public report_view;
	public reportMode;
	public report_generate = new Subject();
	public reportSubheaderMode = new Subject();
	public getTableDatasource = new Subject();
	public pvtableDisplayOptionChange = new Subject();
	public pvtableDisplayOptionChartChange = new Subject();
	public showLegendChange = new Subject();
	public markerFormat = new Subject();
	public setTheme = new Subject();
	public enableMultipleAxisChange = new Subject();
	public routerInfo;
	public fullScreen = [];
	public downloadTableId;
	public isNew: boolean = true;
	// public chooseEntityStep = 1;
	public companyList_entity = [];
	public fundList_entity = [];
	// public saveEntityFields = new Subject();
	public pageLoading_ = new Subject();
	public selectPortfolioData = [];
	public toolbar: boolean = true;
	public properties = new Subject();
	public customized: boolean = false;
	public tabactive: boolean = false;
	public dataSendToFilter = new Subject();
	public portletDownload = new Subject();
	public tableFormat = new Subject();
	public tableFilter = new Subject();
	public changeDataTable = new Subject();
	public changeTable = new Subject();
	public changePivot = new Subject();
	public changeChart = new Subject();
	public changeGeo = new Subject();
	public getFunsInvestee = new Subject();
	public getAllInvesteeActive = new Subject();
	public getDataMartActive = new Subject();
	public fetchSidebar = new Subject();
	public reset_btn = new Subject();
	public changelayout = new Subject();
	public clearSidebar = new Subject();
	public tranposeFilter = new Subject();
	public portletTitle = new Subject();
	public updateDatamartEntity = new Subject();
	public dataMartList = [];
	public createDashboard = new Subject();
	public createDashboardNew = new Subject();
	public changeDashboardShared = new Subject();
	public clearFieldList = new Subject();
	public currentAddStatus = new BehaviorSubject<number>(0);

	constructor() {}

	ngOnInit() {}

	ngOnDestroy(): void {
		this.currentAddStatus.complete();
	}

	changeAddStatus(type: number): void {
		this.currentAddStatus.next(type);
	}
	public getAbs(val) {
		return Math.abs(val);
	}
	public dataExists(val) {
		return !(val === null || val === undefined);
	}
	public getColor(i) {
		const idx = i % this.colorsTotal.length;
		return this.colorsTotal[idx];
	}
	public getColorFromColorArr(i, arr) {
		const idx = i % arr.length;
		return arr[idx];
	}

	getPanesData(): Observable<any> {
		return this.paneData.asObservable();
	}
	getStartRefresh() {
		return this.startRefresh.asObservable();
	}
	getSwitchConfig() {
		return this.switchLabelConfig.asObservable();
	}
	getColNum(): Observable<any> {
		return this.col_num.asObservable();
	}
	getAloneCol(): Observable<any> {
		return this.alone_col.asObservable();
	}
	getFull_dt(): Observable<any> {
		return this.full_dt.asObservable();
	}
	getDashbordGroup(): Observable<any> {
		return this.DashbordGroup.asObservable();
	}
	getportletEdit(): Observable<any> {
		return this.portletEdit.asObservable();
	}
	getaddportlet(): Observable<any> {
		return this.addOrdelPortlet.asObservable();
	}
	getCustomizeStatus(): Observable<any> {
		return this.customize.asObservable();
	}
	getPushbtn(): Observable<any> {
		return this.create_btn.asObservable();
	}
	getDownloadDashbord(): Observable<any> {
		return this.downloadDashboard.asObservable();
	}
	// getIrrDetail(): Observable<any> {
	//     return this.irrDetail.asObservable();
	// }
	getLeftMenuBar(): Observable<any> {
		return this.leftMenuBar.asObservable();
	}
	createGroup(): Observable<any> {
		return this.createGroupDashboard.asObservable();
	}
	getRefreshGadget() {
		return this.refreshGadget.asObservable();
	}

	getGenerateStatus(): Observable<any> {
		return this.report_generate.asObservable();
	}
	changeSubheaderMode(): Observable<any> {
		return this.reportSubheaderMode.asObservable();
	}
	getTablesource(): Observable<any> {
		return this.getTableDatasource.asObservable();
	}
	// saveEntityFields_(): Observable<any> {
	//     return this.saveEntityFields.asObservable();
	// }
	pageLoading_obs(): Observable<any> {
		return this.pageLoading_.asObservable();
	}
	getPvtableDisplayOptionChartChange(): Observable<any> {
		return this.pvtableDisplayOptionChartChange.asObservable();
	}
	getEnableMultipleAxisChange(): Observable<any> {
		return this.enableMultipleAxisChange.asObservable();
	}
	getShowLegendChange(): Observable<any> {
		return this.showLegendChange.asObservable();
	}
	getMarkerFormat(): Observable<any> {
		return this.markerFormat.asObservable();
	}
	getTheme(): Observable<any> {
		return this.setTheme.asObservable();
	}
	editProperties(): Observable<any> {
		return this.properties.asObservable();
	}
	getDataSendToFilter(): Observable<any> {
		return this.dataSendToFilter.asObservable();
	}
	getportletDownload(): Observable<any> {
		return this.portletDownload.asObservable();
	}
	getTableFormat(): Observable<any> {
		return this.tableFormat.asObservable();
	}
	getTableFilter(): Observable<any> {
		return this.tableFilter.asObservable();
	}
	getchangeDataTable(): Observable<any> {
		return this.changeDataTable.asObservable();
	}
	getDashboardRename(): Observable<any> {
		return this.dashboardRename.asObservable();
	}
	getchangeTable(): Observable<any> {
		return this.changeTable.asObservable();
	}
	getchangePivot(): Observable<any> {
		return this.changePivot.asObservable();
	}
	getchangeChart(): Observable<any> {
		return this.changeChart.asObservable();
	}
	getchangeGeo(): Observable<any> {
		return this.changeGeo.asObservable();
	}
	getTagsUpdate(): Observable<any> {
		return this.getFunsInvestee.asObservable();
	}
	getAllInvestee_(): Observable<any> {
		return this.getAllInvesteeActive.asObservable();
	}
	getDataMartActive_(): Observable<any> {
		return this.getDataMartActive.asObservable();
	}
	getResetbtn(): Observable<any> {
		return this.reset_btn.asObservable();
	}
	getchangelayout(): Observable<any> {
		return this.changelayout.asObservable();
	}
	getclearSidebar(): Observable<any> {
		return this.clearSidebar.asObservable();
	}
	watchTranposeFilter(): Observable<any> {
		return this.tranposeFilter.asObservable();
	}
	updatePortletTitle(): Observable<any> {
		return this.portletTitle.asObservable();
	}

	watchUpdateDatamartEntity(): Observable<any> {
		return this.updateDatamartEntity.asObservable();
	}
	createDashboardObservable(): Observable<any> {
		return this.createDashboard.asObservable();
	}
	createDashboardObservableNew(): Observable<any> {
		return this.createDashboardNew.asObservable();
	}

	changeDashboardSharedObservable(): Observable<any> {
		return this.changeDashboardShared.asObservable();
	}
	clearFieldListObservable(): Observable<any> {
		return this.clearFieldList.asObservable();
	}

	getUpdated(): Observable<any> {
		return this.chartUpdate.asObservable();
	}

	dashboardNavigateObservable() {
		return this.dashboardNavigate.asObservable();
	}

	getChartTypeChange(): Observable<any> {
		return this.chartTypeChange.asObservable();
	}
}
